import { FETCH_ISL_REWARDS } from '../actionTypes';

const getISLRewards = (state = [], action) => {
    switch (action.type) {
        case FETCH_ISL_REWARDS:
            state = [];
            return [...state, ...action.islRewards];
        default:
            return state;
    }

};

export default getISLRewards;